export default {"src":"/_next/static/media/lotto.33ae28a6.svg","height":24,"width":24};